import React from "react";
import Navbar from "../connected/Navbar";
import BlogHeroSection from "../sections/BlogSection/BlogHeroSection";
import Footer from "../connected/Footer";
import BlogBody from "../sections/BlogSection/BlogBody";
import PageHeader from "../primitive/PageHeader";

const Blog = () => {
  return (
    <div>
      <PageHeader browserTitle="Blog | Smartcomply Seequre" />
      <div className="get_in_touch_hero_section_bg">
        <Navbar />
        <BlogHeroSection />
      </div>
      <BlogBody />
      <Footer />
    </div>
  );
};

export default Blog;
